import { slick } from "@accessible360/accessible-slick";
import FilterListing  from './FilterListing';

class WhatSparksInterest {
    constructor(element) {
        //elements
        this.whatSparksInterestBlock = element;
        this.form = element.querySelector('form');
        this.carousel = element.querySelector('[data-carousel="what-sparks-interest"]');
        this.featuredTemplate = document.getElementById('featured-content');

        //filters
        this.checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
        this.filteredData = [];
        this.activeFilters = 0;
        this.getSelectedFilters = [];

        //data
        this.jsonData = []; 

        //buttons
        this.surpriseMeButton = document.querySelector('.surprise-me');

        //carousel
        this.slickCarousel = {};

        this.init();
    }

    init() {
        this.jsonData = this.fetchJsonData();
        if (!this.jsonData) return;
        this.createCarousel();
        this.setupEventListeners();
        this.filterCards();
    }

    fetchJsonData() {
        const jsonDataElement = document.getElementById('json-data');
        return jsonDataElement ? JSON.parse(jsonDataElement.innerHTML) : [];
    }

    setupEventListeners() {
        this.setupCheckboxListener();
        this.setupSurpriseMeButton();
    }

    createCarousel() {
        let props = {
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            infinite: false,
            speed: 400,
            swipeToSlide: true,
            adaptiveHeight: false,
            prevArrow: ".custom-arrow-prev",
            nextArrow: ".custom-arrow-next",
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 821,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        };

        // Init slick carousel.
        let carousel = $(this.carousel).slick(props);

        this.slickCarousel = carousel;
    }

    setupCheckboxListener() {
        // attach event listener to the form
        this.form.addEventListener("change", (e) => {
            if (e.target && e.target.type === "checkbox") {

                // toggle active class on label associated with the checkbox
                const label = e.target.nextElementSibling;
                if (label) {
                    label.classList.toggle('active', e.target.checked);
                }

                const anyChecked = Array.from(this.checkboxes).some(checkbox => checkbox.checked);
                const postCounts = document.querySelectorAll('.post-count');

                postCounts.forEach(postCount => {
                    if (anyChecked) {
                        postCount.style.opacity = 0;
                    } else {
                        postCount.style.opacity = 1;
                    }
                });

                this.filtersActive();
                this.filterCards();
            }
        });
    }

    setupSurpriseMeButton() {
        this.surpriseMeButton.addEventListener('click', (e) => {
            e.preventDefault();
            FilterListing.shuffleArray(this.jsonData); 
            this.filterCards(); 
        });
    }

    showFeaturedContent() {
        if (this.featuredTemplate) {
            const clone = document.importNode(this.featuredTemplate.content, true); 
            this.carousel.appendChild(clone); 
        }
    }

    filtersActive() {
        this.activeFilters = Array.from(this.checkboxes)
            .filter(checkbox => checkbox.checked)
            .length;
        if(this.activeFilters !== 0) {
            this.surpriseMeButton.style.display = 'none';
        } else {
            this.surpriseMeButton.style.display = 'inline-flex';
        }
    }

    removeAllSlides() {
        const slideCount = $(this.carousel).slick('getSlick').slideCount;
        if(slideCount >= 1) {
            for (let i = slideCount - 1; i >= 0; i--) {
                $(this.carousel).slick('slickRemove', i); // remove each slide by its index, in reverse order
            }
        }
    }

    filterCards() {
        this.carousel.classList.remove('show');
        this.selectedFilters = FilterListing.getSelectedFilters(this.form);
        this.filteredData = FilterListing.getMatchingData(this.selectedFilters, this.jsonData);
        this.renderCards()
    }

    renderCards() {
       
        this.removeAllSlides();
        
        //destroy slick
        $(this.carousel).slick('unslick');
        

        //add cards
        for (let i = 0; i < this.filteredData.length; i++) {
            if (i >= 15) {
                break; 
            }
            const item = this.filteredData[i];
            const cardHTML = FilterListing.createCardHTML(item, true);
            this.carousel.insertAdjacentHTML('beforeend', cardHTML);
        }

        this.showFeaturedContent();

        //reinstate slick
        this.createCarousel();
        setTimeout(() => {
            this.carousel.classList.add('show');
        }, 300);
    }

}

document.addEventListener("DOMContentLoaded", () => {
    const whatSparksInterestEl = document.querySelector('.what-sparks-interest');
    if(whatSparksInterestEl) {
        new WhatSparksInterest(whatSparksInterestEl);
    }
});

export default WhatSparksInterest;
